<template>   
   <HeaderDash />
   <SideMenu />
   <ContentDash />
</template>

<script>

import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentDash from '@/components/team/dashboard/modules/main/ContentDash.vue'

export default 
{
  name: 'Dashboard',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentDash 
  }
}
</script>

<style>

</style>